import DomainEntity from '@/models/DomainEntity'

export default class StateOldStaff extends DomainEntity {
  static get collectionName() {
    return 'stateoldstaff/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
